import type { ValidationError as SubmissionValidationError } from '@/api/responses';
import type { FormQuestion } from '@kushya/shared';

interface ValidationSummaryProps {
  validationErrors: SubmissionValidationError[];
  questions: FormQuestion[];
}

export function ValidationSummary({ validationErrors, questions }: ValidationSummaryProps) {
  if (validationErrors.length === 0) {
    return null;
  }

  return (
    <div className="rounded-md border border-destructive/20 bg-destructive/5 p-4 text-sm text-destructive">
      <h3 className="mb-2 font-semibold">Please correct the following:</h3>
      <ul className="space-y-1 text-left">
        {validationErrors.map((validationError) => {
          const relatedQuestion = questions.find(
            (question) => question.ref === validationError.questionRef,
          );
          const label =
            relatedQuestion?.title ?? validationError.questionTitle ?? validationError.questionRef;

          return (
            <li key={validationError.questionRef}>
              <span className="font-medium">{label}:</span> {validationError.message}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
